import { FC, ReactNode } from "react";
import { formStyles } from "shared/ui";

import styles from "./CreateWheelRaffleForm.module.css";

interface Props {
  label: string;
  hint?: string;
  children: ReactNode;
}

// Подпись над полем: placeholder у полей дат не несёт названия.
export const LabeledInput: FC<Props> = ({ label, hint, children }) => (
  <div className={styles.group}>
    <span className={styles.label}>{label}</span>
    {children}
    {hint && <p className={formStyles.hint}>{hint}</p>}
  </div>
);
